import invariant from 'invariant';
import { ComponentProps, ReactElement } from 'react';

import { AnchorButton } from 'components/Button/AnchorButton';
import { CmsApiLink, CmsApiLinkType } from 'modules/cms/api/types/CmsApiLink';

import { CmsDownloadButton } from './CmsDownloadButton';
import { CmsLinkButton } from './CmsLinkButton';
import { CmsSubscribeButton } from './CmsSubscribeButton';

type Props = {
  buttonData: CmsApiLink;
  eventProperties: Record<string, unknown>;
  children: ReactElement<ComponentProps<typeof AnchorButton>>;
  blockId?: string;
  sectionIndex?: number;
};

/*
 * A generic button that handles all types of CMS "call to action" buttons
 */
export function CmsButton(props: Props) {
  const { eventProperties, buttonData, children, blockId, sectionIndex } =
    props;

  if (buttonData.type === CmsApiLinkType.S3_FILE) {
    return (
      <CmsDownloadButton
        buttonData={buttonData}
        eventProperties={{ cta_type: 'button', ...eventProperties }}
      >
        {children}
      </CmsDownloadButton>
    );
  }

  if (buttonData.type === CmsApiLinkType.SUBSCRIBE) {
    invariant(blockId !== undefined, 'Missing block id for CmsButton');
    invariant(
      sectionIndex !== undefined,
      'Missing section index for CmsButton',
    );
    return (
      <CmsSubscribeButton
        buttonData={buttonData}
        blockId={blockId}
        sectionIndex={sectionIndex}
        eventProperties={{ cta_type: 'button', ...eventProperties }}
      >
        {children}
      </CmsSubscribeButton>
    );
  }

  if (
    buttonData.type === CmsApiLinkType.URL ||
    buttonData.type === CmsApiLinkType.CMS_PAGE
  ) {
    return (
      <CmsLinkButton
        buttonData={buttonData}
        eventProperties={{ cta_type: 'button', ...eventProperties }}
      >
        {children}
      </CmsLinkButton>
    );
  }

  return null;
}
